import React from 'react';
import Divider from 'src/shared-components/Divider';
import { PayoutDates } from '../..';

const PayoutDatesRow = ({ payoutDates }: { payoutDates: PayoutDates }) => {
  function hasDatePassed(dateString) {
    // Parse the date string and create a Date object
    const [month, day, year] = dateString.split('/');
    // Adjust for 'yy' format to 'yyyy' assuming that '00'-'49' is '2000'-'2049'
    // and '50'-'99' is '1950'-'1999'
    const fullYear = parseInt(year, 10) < 50 ? `20${year}` : `19${year}`;
    const dateObject = new Date(`${fullYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`);

    // Get today's date without time for a fair comparison
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Compare the two dates
    return dateObject < today;
  }

  function isDateWithin20Days(dateString) {
    // Parse the date string and create a Date object
    const [month, day, year] = dateString.split('/');
    // Adjust for 'yy' format to 'yyyy' assuming that '00'-'49' is '2000'-'2049'
    // and '50'-'99' is '1950'-'1999'
    const fullYear = parseInt(year, 10) < 50 ? `20${year}` : `19${year}`;
    const dateObject = new Date(`${fullYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`);

    // Get today's date and the date 20 days from now
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset hours to start of the day
    const twentyDaysLater = new Date(today);
    twentyDaysLater.setDate(today.getDate() + 20); // Set to 20 days later

    // Check if the date is within today and the next 20 days
    return dateObject >= today && dateObject <= twentyDaysLater;
  }

  const getRowColor = (dateString: string) => {
    if (hasDatePassed(dateString)) return 'opacity-25';
    if (isDateWithin20Days(dateString)) return 'text-green-600';
    return 'text-black opacity-25';
  };

  return (
    <div className="mt-1">
      <Divider />
      <div className={getRowColor(payoutDates.firstPayoutDate)}>
        <div className="flex flex-row justify-between ml-auto mb-3 mt-3">
          <div className="">{payoutDates.payout.hours / 2}</div>
          <div className="">${payoutDates.payout.hourlyRate}</div>
          <div className="">${payoutDates.payout.totalAmount / 2}</div>
          <div className="">{payoutDates.firstPayoutDate}</div>
        </div>
      </div>

      <Divider />
      <div className={getRowColor(payoutDates.secondPayoutDate)}>
        <div className="flex flex-row justify-between ml-auto mb-3 mt-3">
          <div className="">{payoutDates.payout.hours / 2}</div>
          <div className="">${payoutDates.payout.hourlyRate}</div>
          <div className="">${payoutDates.payout.totalAmount / 2}</div>
          <div className="">{payoutDates.secondPayoutDate}</div>
        </div>
      </div>
    </div>
  );
};

export default PayoutDatesRow;
